import { ContractType } from 'app/constants/contractType'

export const getContractTypeName = (
  type: ContractType,
  translate: (string) => string,
): string => {
  let text = '-'

  switch (type) {
    case ContractType.Basic:
      text = 'contractType.basic'
      break
    case ContractType.CivilLawAgreement:
      text = 'contractType.civil-law-agreement'
      break
    case ContractType.Equivalent:
      text = 'contractType.equivalent'
      break
    case ContractType.Intermittent:
      text = 'contractType.intermittent'
      break
    case ContractType.Mix:
      text = 'contractType.mix'
      break
    case ContractType.SelfEmployment:
      text = 'contractType.self-employment'
      break
    case ContractType.Task:
      text = 'contractType.task'
      break
  }

  return text != '-' ? translate(text) : text
}
